(() => {
  if (customElements.get('figs-custom-sizing')) return;
  const norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  class FigsCustomSizing extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const source = this.querySelector('[data-fcs-catalog]');
      if (!source) return;
      this.abort = new AbortController();
      this.products = []; this.filter = 'all'; this.mode = 'mixed'; this.color = ''; this.product = null;
      this.fee = Number(this.dataset.fee) || 0;
      const amount = value => { const raw = String(value || '').trim().replace(',', '.'); return /^\d+(\.\d{1,2})?$/.test(raw) ? Number(raw) : null; };
      this.delivery = amount(this.dataset.delivery); if (this.delivery !== null) this.delivery = Math.round(this.delivery * 100);
      this.palette = {};
      try { const raw = JSON.parse(this.q('[data-fcs-palette]')?.textContent || '""') || ''; raw.split('\n').forEach(line => { const [name, hex] = line.split('='); if (name && /^#[0-9a-f]{6}$/i.test(hex?.trim())) this.palette[norm(name)] = hex.trim(); }); } catch (_) {}

      this.money = value => new Intl.NumberFormat('fr-MA', {style:'currency', currency:this.dataset.currency || 'MAD', maximumFractionDigits:2}).format(value / 100);
      try { this.ingest(JSON.parse(source.textContent)); } catch (_) { this.q('[data-loading]').textContent = 'Le catalogue ne peut pas être chargé. Merci de réessayer.'; return; }
      if (this.dataset.currency !== 'MAD' || this.dataset.shopCurrency !== 'MAD') {
        this.q('[data-loading]').textContent = 'Cette demande est disponible en dirhams marocains. Sélectionnez le Maroc dans le sélecteur de pays pour continuer.'; return;
      }
      this.q('[data-fee-label]').textContent = `+ ${this.money(this.fee)}`;
      this.updateTerms();
      this.q('[data-loading]').hidden = true; this.q('[data-fcs-app]').hidden = false;
      this.bind(); this.renderProducts(); this.preselect(); this.loadRemaining();
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
    q(selector) { return this.querySelector(selector); }
    qa(selector) { return [...this.querySelectorAll(selector)]; }
    ingest(data) {
      for (const product of data.products || []) {
        if (this.products.some(p => p.handle === product.handle)) continue;
        product.ci = product.options.findIndex(o => /^(couleur|color|colour|colors|couleurs)$/.test(norm(o.name)));
        product.si = product.options.findIndex(o => /^(size|taille|tailles|sizes|taille de l'ensemble)$/.test(norm(o.name)));
        const recognized = product.options.every((_, i) => i === product.ci || i === product.si);
        // Unsupported option structures must never produce an ambiguous order.
        if (!recognized || product.si < 0 || Number(product.variantsCount) >= 250 || !product.variants?.length) continue;
        const allowed = Array.isArray(product.allowedColors) ? product.allowedColors.map(norm) : [];
        const allColors = [...new Set(product.variants.map(v => product.ci < 0 ? 'Coloris unique' : v.options[product.ci]))];
        product.colors = allColors.filter(color => allowed.length ? allowed.includes(norm(color)) : product.variants.some(v => v.available && (product.ci < 0 || v.options[product.ci] === color)));
        if (!product.colors.length) continue;
        const text = norm([product.title, product.type, ...(product.tags || [])].join(' '));
        product.gender = /unisex|mixte/.test(text) ? 'unisex' : /\bfemme\b|\bwomen\b|\bwoman\b/.test(text) ? 'femme' : /\bhomme\b|\bmen\b|\bman\b/.test(text) ? 'homme' : 'unisex';
        this.products.push(product);
      }
      this.next = data.next || null;
    }
    async loadRemaining() {
      this.q('[data-retry]').hidden = true;
      while (this.next && this.isConnected) {
        try {
          const url = new URL(this.next, window.location.href); url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, {signal:this.abort.signal});
          if (!response.ok) throw new Error('catalog');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('[data-fcs-catalog]');
          if (!source) throw new Error('catalog');
          const previous = this.next; this.ingest(JSON.parse(source.textContent));
          if (this.next === previous) throw new Error('pagination');
          this.renderProducts(); this.preselect();
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.q('[data-catalog-status]').textContent = 'Certains modèles n’ont pas pu être chargés. Réessayez pour voir toute la sélection.';
          this.q('[data-retry]').hidden = false; return;
        }
      }
    }
    bind() {
      const options = {signal:this.abort.signal};
      this.addEventListener('click', e => {
        const button = e.target.closest('button'); if (!button) return;
        if (button.dataset.model) this.selectProduct(button.dataset.model);
        if (button.dataset.filter) { this.filter = button.dataset.filter; this.qa('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button))); this.renderProducts(); }
        if (button.dataset.color !== undefined) { this.color = button.dataset.color; this.renderOptions(); }
        if (button.dataset.back) this.step(Number(button.dataset.back));
        if (button.hasAttribute('data-next')) this.recap();
        if (button.hasAttribute('data-retry')) this.loadRemaining();
      }, options);
      this.q('[data-search]').addEventListener('input', () => this.renderProducts(), options);
      this.addEventListener('change', e => {
        if (e.target.matches('input[type="radio"]')) { this.mode = e.target.value; this.updateMode(); }
        if (e.target.matches('[data-top], [data-bottom]')) { this.q('[data-error]').textContent = ''; this.updatePrice(); }
      }, options);
    }
    renderProducts() {
      const query = norm(this.q('[data-search]').value);
      const shown = this.products.filter(p => (this.filter === 'all' || p.gender === this.filter || p.gender === 'unisex') && norm(p.title).includes(query));
      const grid = this.q('[data-products]'); grid.replaceChildren();
      for (const p of shown) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'fcs-card'; b.dataset.model = p.handle;
        if (p.image) { const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy'; img.width = 350; img.height = 438; b.append(img); }
        const title = document.createElement('strong'); title.textContent = p.title;
        const price = document.createElement('span'); price.textContent = `À partir de ${this.money(p.price)}`;
        b.append(title, price); grid.append(b);
      }
      this.q('[data-catalog-status]').textContent = shown.length ? `${shown.length} modèle${shown.length > 1 ? 's' : ''}${this.next ? ' · Chargement de la suite…' : ''}` : 'Aucun modèle pour cette recherche.';
    }
    preselect() {
      if (this.preselectionDone || this.product) return;
      const query = new URLSearchParams(window.location.search);
      const p = this.products.find(p => p.handle === query.get('model')); if (!p) return;
      this.preselectionDone = true;
      const variant = p.variants.find(v => String(v.id) === query.get('variant'));
      this.selectProduct(p.handle, variant, false);
    }
    selectProduct(handle, variant = null, focus = true) {
      this.product = this.products.find(p => p.handle === handle); if (!this.product) return;
      const p = this.product;
      this.color = variant && p.colors.includes(variant.options[p.ci]) ? variant.options[p.ci] : p.colors[0];
      this.mode = 'mixed'; this.qa('input[type="radio"]').forEach(r => r.checked = r.value === 'mixed');
      this.q('[data-selected-title]').textContent = p.title;
      this.q('[data-top]').value = ''; this.q('[data-bottom]').value = '';
      this.renderOptions(); this.updateMode(); this.step(2, focus);
    }
    colorVariants() { const p = this.product; return p.variants.filter(v => p.ci < 0 || v.options[p.ci] === this.color); }
    renderOptions() {
      const p = this.product, colors = this.q('[data-colors]'); colors.replaceChildren();
      this.q('[data-color-name]').textContent = this.color;
      p.colors.forEach(color => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'fcs-swatch'; b.dataset.color = color; b.title = color; b.setAttribute('aria-label', color); b.setAttribute('aria-pressed', String(color === this.color));
        const dot = document.createElement('span'); dot.className = 'fcs-swatch-dot'; dot.setAttribute('aria-hidden','true');
        const native = (p.swatches || []).find(v => v.name === color);
        const hex = native?.color || this.palette[norm(color)];
        const thumb = native?.image || p.variants.find(v => (p.ci < 0 || v.options[p.ci] === color) && v.image)?.image;
        if (native?.image || (!hex && thumb)) { const img = document.createElement('img'); img.src = native?.image || thumb; img.alt = ''; dot.append(img); }
        else if (hex && CSS.supports('color', hex)) dot.style.backgroundColor = hex;
        else { dot.textContent = color.slice(0,2); dot.style.backgroundColor = '#f0f0eb'; }
        b.append(dot); colors.append(b);
      });
      const variants = this.colorVariants();
      const image = variants.find(v => v.image)?.image || p.image;
      const img = this.q('[data-selected-image]'); img.hidden = !image; if (image) img.src = image; else img.removeAttribute('src'); img.alt = `${p.title} — ${this.color}`;
      const sizes = [...new Set(variants.map(v => v.options[p.si]))];
      for (const select of [this.q('[data-top]'), this.q('[data-bottom]')]) {
        const old = select.value; select.replaceChildren(new Option('Choisir', ''));
        sizes.forEach(size => select.add(new Option(size, size)));
        if (sizes.includes(old)) select.value = old;
      }
      this.q('[data-error]').textContent = ''; this.updatePrice();
    }
    deliveryTime() {
      return this.mode === 'custom'
        ? (this.dataset.deliveryTime || '7 jours après validation de votre demande et réception du paiement en avance.')
        : 'Livraison selon nos délais habituels, confirmés sur WhatsApp.';
    }
    updateTerms() {
      this.q('[data-terms]').textContent = `Livraison au Maroc${this.delivery === null ? ' : frais à confirmer' : ' : ' + this.money(this.delivery)}. Paiement en avance requis. ${this.deliveryTime()}`;
    }
    updateMode() {
      this.updateTerms();
      this.q('[data-sizes]').hidden = this.mode !== 'mixed';
      this.q('[data-measurements]').hidden = this.mode !== 'custom';
      this.updateMeasurements();
      this.q('[data-error]').textContent = ''; this.updatePrice();
    }
    updateMeasurements() {
      this.qa('[data-measure]').forEach(input => { input.disabled = this.mode !== 'custom'; input.required = !input.disabled && input.dataset.mandatory === 'true'; });
      this.q('[data-error]').textContent = '';
    }
    measurements() {
      if (this.mode !== 'custom') return [];
      return this.qa('[data-measure]').filter(input => input.value.trim()).map(input => [input.dataset.label, input.value]);
    }
    pricing() {
      let variants = this.colorVariants();
      if (this.mode === 'mixed') {
        const top = this.q('[data-top]').value, bottom = this.q('[data-bottom]').value;
        if (top && bottom) variants = variants.filter(v => [top,bottom].includes(v.options[this.product.si]));
      }
      const prices = variants.map(v => v.price);
      this.estimate = new Set(prices).size > 1;
      this.base = Math.max(...prices); this.total = this.base + (this.mode === 'custom' ? this.fee : 0);
    }
    updatePrice() { this.pricing(); this.q('[data-price]').textContent = `${this.money(this.total)}${this.estimate ? ' · estimation à confirmer' : ''}`; }
    step(number, focus = true) {
      this.dataset.activeStep = number;
      this.qa('[data-step]').forEach(el => el.hidden = Number(el.dataset.step) !== number);
      this.qa('[data-progress]').forEach(el => { if (Number(el.dataset.progress) === number) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current'); });
      if (focus) this.q(`[data-step="${number}"] h2`).focus({preventScroll:false});
    }
    recap() {
      this.q('[data-error]').textContent = '';
      const top = this.q('[data-top]').value, bottom = this.q('[data-bottom]').value;
      if (this.mode === 'mixed' && (!top || !bottom)) { this.q('[data-error]').textContent = 'Choisissez la taille du haut et du pantalon.'; this.q(!top ? '[data-top]' : '[data-bottom]').focus(); return; }
      if (this.mode === 'custom') {
        const invalid = this.qa('[data-measure]').find(input => !input.checkValidity());
        if (invalid) { this.q('[data-error]').textContent = 'Complétez les mesures obligatoires avec des valeurs positives (une décimale maximum).'; invalid.reportValidity(); invalid.focus(); return; }
      }
      const phone = this.dataset.phone.replace(/\D/g, '');
      if (!/^[1-9]\d{7,14}$/.test(phone)) { this.q('[data-error]').textContent = 'Le contact WhatsApp est momentanément indisponible.'; return; }
      this.pricing(); const p = this.product;
      this.q('[data-recap-title]').textContent = p.title; this.q('[data-recap-color]').textContent = this.color;
      const recapImage = this.q('[data-recap-image]'), selectedImage = this.q('[data-selected-image]');
      recapImage.hidden = selectedImage.hidden; if (!selectedImage.hidden) recapImage.src = selectedImage.src; else recapImage.removeAttribute('src'); recapImage.alt = selectedImage.alt;
      const summary = this.q('[data-summary]'); summary.replaceChildren();
      const entries = this.mode === 'custom' ? [['Taille','À mes mesures'],...this.measurements(),['Supplément',this.money(this.fee)]] : [['Haut',top],['Pantalon',bottom],['Supplément',this.money(0)]];
      if (this.mode === 'custom' && this.q('[data-measure-notes]').value.trim()) entries.push(['Précisions',this.q('[data-measure-notes]').value.trim()]);
      entries.forEach(([key,value]) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = key; dd.textContent = value; summary.append(dt,dd); });
      const grand = this.total + (this.delivery || 0);
      const shippingLabel = this.delivery === null ? 'À confirmer selon la destination' : this.delivery === 0 ? 'Offerte' : this.money(this.delivery);
      const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = 'Livraison'; dd.textContent = shippingLabel; summary.append(dt,dd);
      this.q('[data-total-label]').textContent = this.delivery === null ? 'Sous-total hors livraison' : 'Total avec livraison';
      this.q('[data-total]').textContent = `${this.money(grand)}${this.estimate ? ' (estimation)' : ''}`;
      const payment = this.q('[data-payment-summary]'); payment.replaceChildren();
      const details = [this.mode === 'custom' ? 'Paiement en avance requis avant confection.' : 'Paiement en avance requis.', this.deliveryTime(), 'Nous vous confirmerons les modalités de paiement sur WhatsApp.'];
      details.forEach(text => { const line = document.createElement('p'); line.textContent = text; payment.append(line); });
      const lines = this.mode === 'custom'
        ? [p.title, `Couleur : ${this.color}`, 'Option : À mes mesures',
          ...this.measurements().map(([label,value]) => {
            const shortLabel = label === 'Votre taille (cm)' ? 'Taille (cm)' : label === 'Votre poids (kg) — facultatif' ? 'Poids (kg)' : label;
            return `${shortLabel} : ${value}`;
          })]
        : [p.title, `Couleur : ${this.color}`, `Haut : ${top}`, `Pantalon : ${bottom}`];
      this.q('[data-whatsapp]').href = `https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`; this.step(3);
    }
  }
  customElements.define('figs-custom-sizing', FigsCustomSizing);
})();
